import * as Phaser from "phaser";
import { BasicScene } from "$/game/prefabs/scenes/BasicScene.ts";
import { PetGameObject } from "$/game/prefabs/PetGameObject.ts";
import { BasketInteractiveObject } from "$/game/prefabs/home/BasketInteractiveObject.ts";
import { PoopItemObject } from "$/game/prefabs/home/PoopItemObject.ts";
import { petActions } from "$/game/emitters.ts";

export class PoopSystem {
  private listOfPoops: Phaser.GameObjects.Image[] = [];

  constructor(
    private myScene: BasicScene,
    private pet: PetGameObject,
    private basket: BasketInteractiveObject,
  ) {
    this.spawnPoops();
    this.myScene.registry.events.on("changedata-pet", () => {
      if (this.myScene && this.myScene.scene && this.myScene.scene.key) {
        this.spawnPoops();
      }
    });
  }

  private spawnPoops(): void {
    const pet = this.myScene.storage.pet();
    for (let i = this.listOfPoops.length; i < pet.poop; i++) {
      const poop = new PoopItemObject(
        this.myScene,
        this.pet.x + Math.random() * 300 - 150,
        this.pet.y + Math.random() * 200,
      );
      this.myScene.add.existing(poop);
      this.listOfPoops.push(poop);
      petActions.poopEmitted();
    }
  }

  public update(): void {
    // Проверяем каждый poop на пересечение с корзиной
    for (let i = this.listOfPoops.length - 1; i >= 0; i--) {
      const poop = this.listOfPoops[i];

      // Проверяем, что poop не перетаскивается (чтобы не удалять во время перетаскивания)
      if (poop instanceof PoopItemObject && poop.dragging) {
        continue;
      }

      // Проверяем пересечение с корзиной
      const poopBounds = poop.getBounds();
      const basketBounds = this.basket.getBounds();

      if (Phaser.Geom.Rectangle.Overlaps(poopBounds, basketBounds)) {
        // Если объект только что закончил перетаскивание, отменяем возврат на исходную позицию
        if (poop instanceof PoopItemObject) {
          poop.setShouldReturn(false);
          // Останавливаем tween возврата, если он был запущен
          poop.stopReturnTween();
        }

        // Удаляем poop из списка и со сцены
        this.removePoop(i);
      }
    }
  }

  private async removePoop(index: number): Promise<void> {
    const poop = this.listOfPoops[index];

    if (!poop || !poop.active) {
      return;
    }

    try {
      // Вызываем API для обновления данных питомца
      this.myScene.api.pet.cleanPoop();
      petActions.poopCleaned();
      this.myScene.soundManager.playSound(
        this.myScene.keys.assets.sounds.cleanPoop,
      );

      if (this.myScene.settings.getSetting("isVibrationEnabled")) {
        this.myScene.telegram.twaSDK.hapticFeedback.impactOccurred("medium");
      }

      // Удаляем из списка
      this.listOfPoops.splice(index, 1);

      // Удаляем со сцены
      poop.destroy();
    } catch (error) {
      console.error("Error removing poop:", error);
    }
  }

  public destroy(): void {
  }
}
